module.exports = __webpack_public_path__ + "img/faq11.c51fe810.png";